import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const MalltERPayPage = lazy(() => import('../pages/mallt-erpay/page'));
const MalltPayPage = lazy(() => import('../pages/mallt-pay/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const MalltPlacePage = lazy(() => import('../pages/mallt-place/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/mallt-erpay',
    element: <MalltERPayPage />,
  },
  {
    path: '/mallt-pay',
    element: <MalltPayPage />,
  },
  {
    path: '/mallt-place',
    element: <MalltPlacePage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
